import gql from "graphql-tag";

export const ADD_REFERENTIAL = gql`
  mutation AddReferential($data: ReferentialDataInput) {
    addReferential(data: $data) {
      id
      name
      type
      entries
    }
  }
`;

export const UPDATE_REFERENTIAL = gql`
  mutation UpdateReferential(
    $data: ReferentialDataInput
    $where: ReferentialWhereInput
  ) {
    updateReferential(data: $data, where: $where) {
      id
      name
      type
      entries
    }
  }
`;

export const DELETE_REFERENTIAL = gql`
  mutation DeleteReferential($where: ReferentialWhereInput) {
    deleteReferential(where: $where) {
      id
    }
  }
`;

export const IMPORT_REFERENTIAL_FROM_FILE = gql`
  mutation ImportReferentialFromFile($data: ReferentialImportDataInput) {
    importReferentialFromFile(data: $data) {
      id
      name
      type
      entries
    }
  }
`;

const geoZones = {
  ADD_REFERENTIAL,
  UPDATE_REFERENTIAL,
  DELETE_REFERENTIAL,
  IMPORT_REFERENTIAL_FROM_FILE,
};

export default geoZones;
